<template>
	<v-dialog v-model="dialog" persistent>
		<v-card>
			<v-card-title class="headline text-center">
				<v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
				¡Comparte!</v-card-title
			>

			<v-card-text align="center">
				<v-btn icon @click="generateLink('cp')"><v-icon>mdi-content-copy</v-icon></v-btn>
				<v-btn icon color="red" @click="generateLink('em')"
					><v-icon>mdi-email</v-icon></v-btn
				>
				<v-btn icon color="blue" @click="generateLink('tw')"
					><v-icon>mdi-twitter</v-icon></v-btn
				>
				<v-btn icon color="blue darken-4" @click="generateLink('fb')"
					><v-icon>mdi-facebook</v-icon></v-btn
				>
				<v-btn icon color="green" @click="generateLink('wp')"
					><v-icon>mdi-whatsapp</v-icon></v-btn
				>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: ["dialog", "data"],
	data: () => ({}),
	methods: {
		closeModal() {
			this.$emit("closeShare");
		},
		generateLink(redS) {
			let contTo;
			let newCont;
			let url;
			let linka;
			let asunto;
			let cuerpo;
			this.$ua.trackEvent(`CplusInteraccion`, "ShareTitle", this.data.title);

			switch (redS) {
				case "tw":
					//Twitter
					contTo =
						this.data.title +
						"\n" +
						this.data.text +
						" \n Lee más en: " +
						this.data.url;
					newCont = encodeURIComponent(contTo);
					url = "https://twitter.com/intent/tweet?text=" + newCont;
					//abrir en nueva ventana

					this.$ua.trackEvent(`CplusInteraccion`, "ShareAnuncio", "Twitter");
					window.open(url, "_blank");
					break;

				case "fb":
					//Facebook
					url = encodeURI(window.location.origin);
					linka = "https://www.facebook.com/sharer/sharer.php?u=" + url;
					this.$ua.trackEvent(`CplusInteraccion`, "ShareAnuncio", "Facebook");
					window.open(linka, "_blank");
					break;

				case "em":
					//EMAIL
					asunto = "Centro+ | " + this.data.title;
					cuerpo =
						this.data.text +
						" \n " +
						"Fuente: " +
						this.data.url +
						" \n " +
						"Centro+ " +
						window.location.origin;
					url =
						"mailto:?&subject=" +
						encodeURIComponent(asunto) +
						"&body=" +
						encodeURIComponent(cuerpo);

					this.$ua.trackEvent(`CplusInteraccion`, "ShareAnuncio", "Email");
					window.open(url, "_blank");
					break;

				case "wp":
					cuerpo =
						"*" +
						this.data.title +
						"*" +
						" \n " +
						this.data.text +
						" \n " +
						"Link: " +
						this.data.url +
						" \n " +
						"*Centro* " +
						window.location.origin;
					newCont = encodeURI(cuerpo);
					url = "https://wa.me/?text=" + newCont;
					this.$ua.trackEvent(`CplusInteraccion`, "ShareAnuncio", "Whatsapp");
					window.open(url, "_blank");
					break;

				case "cp":
					navigator.permissions.query({ name: "clipboard-write" }).then(result => {
						if (result.state == "granted" || result.state == "prompt") {
							contTo =
								this.data.title +
								"\n" +
								this.data.text +
								" \n Lee más en: " +
								this.data.url;
							/* write to the clipboard now */
							navigator.clipboard.writeText(contTo);
						}
					});
					this.$ua.trackEvent(`CplusInteraccion`, "ShareAnuncio", "Copy");
					break;
			}

			this.closeModal();
		}
	}
};
</script>

<style></style>
